/***********************
 * INDEX TAB4 CONTENT
 * (GROUPVIDEOCALLS)
 ************************/

import React from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Importing components
import TableCalls from "./GroupCallsTable"
import ChartCalls from "./GroupCallsChart"

const GroupCallsReporting = props => {
  return (
    <>
      <Row>
        <Col>
          <div className="mt-2 mb-1">
            <Row>
              <ChartCalls
                customers={props.customers}
                data={props.data}
                start={props.start}
                end={props.end}
                quickGuide={props.quickGuide}
              ></ChartCalls>
            </Row>
            <Row>
              <TableCalls
                minRows={0}
                selectedType={props.selectedType}
                data={props.data}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

GroupCallsReporting.propTypes = {
  data: PropTypes.any,
  customers: PropTypes.any,
  selectedType: PropTypes.any,
  start: PropTypes.any,
  end: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(GroupCallsReporting)
